import Panel from '@/components/panel/Panel.jsx';
import { FiScissors } from '@/components/react-icons/main';
import RightPaneFieldV2 from '@/components/v2/RightPaneFieldV2.jsx';
import normalizeToArray from '@/lib/normalizeToArray.js';
import argumentSelectors from '@/redux/selectors/argumentSelectors';
import argumentDataSources from '@/schema/argumentDataSources.js';
import appActions from '@/screens/apps/redux/actions/appActions.js';
import stepActions from '@/screens/workflows/redux/actions/stepActions.js';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { randomId } from 'shared/utils/randomId.js';
import ArgumentLabel from '../ArgumentLabel.jsx';
import ArgumentWrapper from '../ArgumentWrapper.jsx';
import SliderClose from './SliderClose.jsx';
import SliderHeader from './SliderHeader.jsx';
import SliderTitle from './SliderTitle.jsx';

const SliceSlider = ({ onClose, dataSource, dataSourcePath, dataSavePath, isTransformAction, isTransformApp, isPostProcessing, disabled = false }) => {
  const [argKey] = useState(randomId());

  const options = useSelector(argumentSelectors[dataSource].activeOptions);
  const sliceOptions = (isTransformAction ? options?.postProcessing?.slices : isTransformApp ? options?.postProcessing?.slices || options?.slices : options?.slices) || [];
  const normalizedOptions = normalizeToArray(sliceOptions);
  const slice = normalizedOptions?.[0];

  const actions = dataSource === argumentDataSources.workflowStep ? stepActions : appActions;
  const computedDataSavePath = dataSavePath ? `${dataSavePath}.options${isPostProcessing ? '.postProcessing' : ''}` : dataSourcePath;

  const handleChange = ({ key, value }) => {
    if (!key || !value) {
      return;
    }

    actions.set(`${computedDataSavePath}.slices`, (slices) => {
      return slices?.map((f, idx) => (idx === 0 ? { ...f, [key]: value } : f));
    });
  };

  const handleDelete = () => {
    actions.set(`${computedDataSavePath}.slices`, []);
    onClose();
  };

  return (
    <>
      <SliderHeader onClose={onClose} showDelete showRun onDelete={handleDelete} disabled={disabled} />
      <SliderTitle
        icon={FiScissors} //
        title="Slice Your Results"
        description="Return a subset of the action results if you don't want all of them."
        helpIconContext={isTransformAction || isTransformApp ? 'transformPanelSliceContext' : 'workflowStepPostSliceContext'}
      />
      <Panel.Section className={'simple-arguments'} headerless key={argKey}>
        <ArgumentWrapper>
          <ArgumentLabel className={'small-gap'} label={'From Record Number'} description={'Include records from this number onwards.'} />
          <RightPaneFieldV2 //
            disabled={disabled}
            placeholder={'From'}
            value={slice?.from}
            type={'lexical'}
            onChange={(value) => handleChange({ key: 'from', value })}
            allowSelfOutput={true}
          />
        </ArgumentWrapper>
        <ArgumentWrapper>
          <ArgumentLabel className={'small-gap'} label={'To Record Number'} description={'Include records up to this number.'} />
          <RightPaneFieldV2 //
            disabled={disabled}
            placeholder={'To'}
            value={slice?.to}
            type={'lexical'}
            onChange={(value) => handleChange({ key: 'to', value })}
            allowSelfOutput={true}
          />
        </ArgumentWrapper>
      </Panel.Section>
      <SliderClose onClose={onClose} />
    </>
  );
};

export default SliceSlider;
